import React, {
    forwardRef,
    useCallback,
    useEffect,
    useImperativeHandle,
    useMemo,
    useRef,
    useState
} from 'react';
import Validate from 'utils/Validate';
import './styles.scss';
import { TextAreaActions, TextAreaProps } from './types';

export const MyTextAreaInput = forwardRef<TextAreaActions, TextAreaProps>(
    (
        {
            label,
            value,
            placeHolder,
            spellCheck,
            maxLength,
            disabled,
            inputStyle,
            styleDisable,
            important,
            styleGroup,
            onKeyPress,
            rightIcon,
            onChangeText,
            styleIconRight,
            onClickRightIcon,
            labelStyles
        }: TextAreaProps,
        ref?: any
    ) => {
        useImperativeHandle(ref, () => ({
            setValue,
            fillValue,
            getValue,
            focus,
            blur,
            setErrorMsg
        }));
        const [textfieldVal, setTextfieldVal] = useState<any>(`${value}`);
        const [errMsg, setErrMsg] = useState<string>('');
        const [isFocus, setIsFocus] = useState<boolean>(false);
        const orgTextInput = useRef<HTMLTextAreaElement>(null);

        useEffect(() => {
            if (onChangeText && isFocus) {
                onChangeText(textfieldVal, placeHolder);
            }
        }, [placeHolder, textfieldVal, value]);

        const setValue = useCallback(
            (text: any) => {
                if (text) {
                    setTextfieldVal?.(text);
                } else {
                    setTextfieldVal?.('');
                }
            },
            []
        );

        useEffect(() => {
            if (!Validate.isEmpty(value)) {
                setValue(value);
            }
        }, [setValue, value]);

        useEffect(() => {
            if (Validate.isEmpty(value)) {
                setIsFocus(false);
            }
        }, [value]);

        const _onChangeText = useCallback((e) => {
            if(e.target.value){
                setTextfieldVal?.(e.target.value);
            }else setTextfieldVal?.('');
            setErrMsg('');
        }, []);

        const getValue = useCallback(() => {
            return textfieldVal?.trim() || '';
        }, [textfieldVal]);



        const fillValue = useCallback(
            (text: any) => {
                setValue(text);
            },
            [setValue]
        );

        const focus = useCallback(() => {
            if (orgTextInput.current) {
                orgTextInput.current?.focus();
            }
            setIsFocus(true);
        }, []);

        const blur = useCallback(() => {
            if (orgTextInput.current) {
                orgTextInput.current?.blur();
            }
            setIsFocus(false);
        }, []);

        const setErrorMsg = useCallback((msg: string) => {
            if (Validate.isStringEmpty(msg)) {
                return;
            }
            setIsFocus(false);
            setErrMsg(msg);
        }, []);

        const errorMessage = useMemo(() => {
            if (!Validate.isStringEmpty(errMsg)) {
                return <div className='messageError'>
                    <span className='text-err'> {errMsg}</span>
                </div>;
            }
            return null;
        }, [errMsg]);

        const handleClick = useCallback(() => {
            onClickRightIcon?.('');
        }, [onClickRightIcon]);

        return (
            <div className={`${styleGroup}`} id='aera-text'>
                {label ? <label className={`${labelStyles} text-black text-normal'>`}>
                    {label}
                    {important && ' *'}
                </label> : ''}
                <div className={isFocus ? 'focus-container' : errMsg ? 'error-input-container' : 'select-container)'}>
                    <textarea
                        ref={orgTextInput}
                        placeholder={placeHolder}
                        value={textfieldVal}
                        onChange={_onChangeText}
                        maxLength={maxLength}
                        disabled={disabled}
                        readOnly={disabled}
                        autoCapitalize={'none'}
                        onFocus={focus}
                        spellCheck={spellCheck || false}
                        onBlur={blur}
                        onKeyUp={onKeyPress}
                        className={`${inputStyle ? `${inputStyle} input-style` : 'input-style'} ${!disabled ? styleDisable : ''}`}
                    />

                    {rightIcon && <img src={rightIcon} className={styleIconRight ? `${styleIconRight}` : 'icon-right'}  onClick={handleClick} />}
                </div>
                {errorMessage}
            </div>
        );
    }
);
